import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { OpusAgentTurnAttachmentFieldsFragmentDoc } from './attachments/useOpusAgentAttachments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OpusAgentEventFragment = { __typename?: 'OpusAgentChatTurnEvent', id: string, index: number, eventType: string, createdAt: string, payload: { __typename?: 'OpusAgentEventPayload', fallbackText?: string | null, assistantText?: { __typename?: 'OpusAgentAssistantText', text: string } | null, thinking?: { __typename?: 'OpusAgentThinking', text: string } | null, toolCall?: { __typename?: 'OpusAgentToolCall', callId?: string | null, toolName: string, label: string, status: string, detail?: string | null, errorSummary?: string | null, mutationNames?: Array<string> | null } | null, planUpdate?: { __typename?: 'OpusAgentPlanUpdate', done: number, total: number, activeStep?: string | null, items: Array<{ __typename?: 'OpusAgentPlanItem', text: string, status: string }> } | null, error?: { __typename?: 'OpusAgentError', message: string, code?: Types.OpusAgentRefusalCode | null } | null, contextCompacted?: { __typename?: 'OpusAgentContextCompacted', summaryChars: number } | null, planProposal?: { __typename?: 'OpusAgentPlanProposal', version: number, title: string, kind: string, summary?: string | null, audience?: string | null, language?: string | null, sources: Array<string>, assumptions: Array<string>, changes: Array<string>, items: Array<{ __typename?: 'OpusAgentPlanProposalItem', title: string, kind?: string | null, summary?: string | null, points: Array<string>, isNew: boolean, section?: string | null }> } | null, questions?: { __typename?: 'OpusAgentQuestions', questions: Array<{ __typename?: 'OpusAgentQuestion', id: string, text: string, options: Array<string>, multiSelect: boolean }> } | null } };

export type OpusAgentCitationFieldsFragment = { __typename?: 'OpusAgentCitation', type: string, title?: string | null, quote?: string | null, libraryItemId?: string | null, url?: string | null };

export type OpusAgentTurnFileFieldsFragment = { __typename?: 'OpusAgentTurnFile', id: string, name: string, contentType: string, sizeBytes: number, rowCount?: number | null, expiresAt: string };

export type OpusAgentTurnFragment = { __typename?: 'OpusAgentChatTurn', id: string, chatId: string, userMessage: string, status: Types.OpusAgentChatTurnStatus, model?: Types.OpusAgentModel | null, createdAt: string, completedAt?: string | null, supersededByEditAt?: string | null, citations: Array<{ __typename?: 'OpusAgentCitation', type: string, title?: string | null, quote?: string | null, libraryItemId?: string | null, url?: string | null }>, files: Array<{ __typename?: 'OpusAgentTurnFile', id: string, name: string, contentType: string, sizeBytes: number, rowCount?: number | null, expiresAt: string }>, attachments: Array<{ __typename?: 'OpusAgentTurnAttachment', id: string, index: number, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, libraryItem?: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null } | null }>, myFeedback?: { __typename?: 'OpusAgentChatTurnFeedback', id: string, selection: Types.FeedbackSelection, text: string } | null, events: Array<{ __typename?: 'OpusAgentChatTurnEvent', id: string, index: number, eventType: string, createdAt: string, payload: { __typename?: 'OpusAgentEventPayload', fallbackText?: string | null, assistantText?: { __typename?: 'OpusAgentAssistantText', text: string } | null, thinking?: { __typename?: 'OpusAgentThinking', text: string } | null, toolCall?: { __typename?: 'OpusAgentToolCall', callId?: string | null, toolName: string, label: string, status: string, detail?: string | null, errorSummary?: string | null, mutationNames?: Array<string> | null } | null, planUpdate?: { __typename?: 'OpusAgentPlanUpdate', done: number, total: number, activeStep?: string | null, items: Array<{ __typename?: 'OpusAgentPlanItem', text: string, status: string }> } | null, error?: { __typename?: 'OpusAgentError', message: string, code?: Types.OpusAgentRefusalCode | null } | null, contextCompacted?: { __typename?: 'OpusAgentContextCompacted', summaryChars: number } | null, planProposal?: { __typename?: 'OpusAgentPlanProposal', version: number, title: string, kind: string, summary?: string | null, audience?: string | null, language?: string | null, sources: Array<string>, assumptions: Array<string>, changes: Array<string>, items: Array<{ __typename?: 'OpusAgentPlanProposalItem', title: string, kind?: string | null, summary?: string | null, points: Array<string>, isNew: boolean, section?: string | null }> } | null, questions?: { __typename?: 'OpusAgentQuestions', questions: Array<{ __typename?: 'OpusAgentQuestion', id: string, text: string, options: Array<string>, multiSelect: boolean }> } | null } }> };

export type OpusAgentChatModelSeedFragment = { __typename?: 'OpusAgentChat', model?: Types.OpusAgentModel | null };

export type OpusAgentChatQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type OpusAgentChatQuery = { __typename?: 'Query', OpusAgentChat?: { __typename?: 'OpusAgentChat', id: string, createdAt: string, model?: Types.OpusAgentModel | null, turns: Array<{ __typename?: 'OpusAgentChatTurn', id: string, chatId: string, userMessage: string, status: Types.OpusAgentChatTurnStatus, model?: Types.OpusAgentModel | null, createdAt: string, completedAt?: string | null, supersededByEditAt?: string | null, citations: Array<{ __typename?: 'OpusAgentCitation', type: string, title?: string | null, quote?: string | null, libraryItemId?: string | null, url?: string | null }>, files: Array<{ __typename?: 'OpusAgentTurnFile', id: string, name: string, contentType: string, sizeBytes: number, rowCount?: number | null, expiresAt: string }>, attachments: Array<{ __typename?: 'OpusAgentTurnAttachment', id: string, index: number, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, libraryItem?: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null } | null }>, myFeedback?: { __typename?: 'OpusAgentChatTurnFeedback', id: string, selection: Types.FeedbackSelection, text: string } | null, events: Array<{ __typename?: 'OpusAgentChatTurnEvent', id: string, index: number, eventType: string, createdAt: string, payload: { __typename?: 'OpusAgentEventPayload', fallbackText?: string | null, assistantText?: { __typename?: 'OpusAgentAssistantText', text: string } | null, thinking?: { __typename?: 'OpusAgentThinking', text: string } | null, toolCall?: { __typename?: 'OpusAgentToolCall', callId?: string | null, toolName: string, label: string, status: string, detail?: string | null, errorSummary?: string | null, mutationNames?: Array<string> | null } | null, planUpdate?: { __typename?: 'OpusAgentPlanUpdate', done: number, total: number, activeStep?: string | null, items: Array<{ __typename?: 'OpusAgentPlanItem', text: string, status: string }> } | null, error?: { __typename?: 'OpusAgentError', message: string, code?: Types.OpusAgentRefusalCode | null } | null, contextCompacted?: { __typename?: 'OpusAgentContextCompacted', summaryChars: number } | null, planProposal?: { __typename?: 'OpusAgentPlanProposal', version: number, title: string, kind: string, summary?: string | null, audience?: string | null, language?: string | null, sources: Array<string>, assumptions: Array<string>, changes: Array<string>, items: Array<{ __typename?: 'OpusAgentPlanProposalItem', title: string, kind?: string | null, summary?: string | null, points: Array<string>, isNew: boolean, section?: string | null }> } | null, questions?: { __typename?: 'OpusAgentQuestions', questions: Array<{ __typename?: 'OpusAgentQuestion', id: string, text: string, options: Array<string>, multiSelect: boolean }> } | null } }> }> } | null };

export type OpusAgentDefaultModelQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OpusAgentDefaultModelQuery = { __typename?: 'Query', OpusAgentDefaultModel: Types.OpusAgentModel };

export type OpusAgentMostRecentChatQueryVariables = Types.Exact<{
  agentId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type OpusAgentMostRecentChatQuery = { __typename?: 'Query', OpusAgentChats: { __typename?: 'OpusAgentChats', objects: Array<{ __typename?: 'OpusAgentChat', id: string }> } };

export type OpusAgentTurnsQueryVariables = Types.Exact<{
  input: Types.OpusAgentTurnsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type OpusAgentTurnsQuery = { __typename?: 'Query', OpusAgentTurns: { __typename?: 'OpusAgentTurns', objects: Array<{ __typename?: 'OpusAgentChatTurn', id: string, status: Types.OpusAgentChatTurnStatus, completedAt?: string | null, supersededByEditAt?: string | null, citations: Array<{ __typename?: 'OpusAgentCitation', type: string, title?: string | null, quote?: string | null, libraryItemId?: string | null, url?: string | null }>, files: Array<{ __typename?: 'OpusAgentTurnFile', id: string, name: string, contentType: string, sizeBytes: number, rowCount?: number | null, expiresAt: string }> }> } };

export type OpusAgentTurnPreviewsQueryVariables = Types.Exact<{
  input: Types.OpusAgentTurnsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type OpusAgentTurnPreviewsQuery = { __typename?: 'Query', OpusAgentTurns: { __typename?: 'OpusAgentTurns', objects: Array<{ __typename?: 'OpusAgentChatTurn', id: string, partialText?: string | null }> } };

export type OpusAgentTurnEventsQueryVariables = Types.Exact<{
  input: Types.OpusAgentTurnEventsInput;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type OpusAgentTurnEventsQuery = { __typename?: 'Query', OpusAgentTurnEvents: { __typename?: 'OpusAgentTurnEvents', objects: Array<{ __typename?: 'OpusAgentChatTurnEvent', id: string, index: number, eventType: string, createdAt: string, payload: { __typename?: 'OpusAgentEventPayload', fallbackText?: string | null, assistantText?: { __typename?: 'OpusAgentAssistantText', text: string } | null, thinking?: { __typename?: 'OpusAgentThinking', text: string } | null, toolCall?: { __typename?: 'OpusAgentToolCall', callId?: string | null, toolName: string, label: string, status: string, detail?: string | null, errorSummary?: string | null, mutationNames?: Array<string> | null } | null, planUpdate?: { __typename?: 'OpusAgentPlanUpdate', done: number, total: number, activeStep?: string | null, items: Array<{ __typename?: 'OpusAgentPlanItem', text: string, status: string }> } | null, error?: { __typename?: 'OpusAgentError', message: string, code?: Types.OpusAgentRefusalCode | null } | null, contextCompacted?: { __typename?: 'OpusAgentContextCompacted', summaryChars: number } | null, planProposal?: { __typename?: 'OpusAgentPlanProposal', version: number, title: string, kind: string, summary?: string | null, audience?: string | null, language?: string | null, sources: Array<string>, assumptions: Array<string>, changes: Array<string>, items: Array<{ __typename?: 'OpusAgentPlanProposalItem', title: string, kind?: string | null, summary?: string | null, points: Array<string>, isNew: boolean, section?: string | null }> } | null, questions?: { __typename?: 'OpusAgentQuestions', questions: Array<{ __typename?: 'OpusAgentQuestion', id: string, text: string, options: Array<string>, multiSelect: boolean }> } | null } }> } };

export type SendOpusAgentMessageMutationVariables = Types.Exact<{
  input: Types.SendOpusAgentMessageInput;
}>;


export type SendOpusAgentMessageMutation = { __typename?: 'Mutation', sendOpusAgentMessage: { __typename?: 'SendOpusAgentMessageResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, turn?: { __typename?: 'OpusAgentChatTurn', id: string, chatId: string, userMessage: string, status: Types.OpusAgentChatTurnStatus, model?: Types.OpusAgentModel | null, createdAt: string, completedAt?: string | null, supersededByEditAt?: string | null, citations: Array<{ __typename?: 'OpusAgentCitation', type: string, title?: string | null, quote?: string | null, libraryItemId?: string | null, url?: string | null }>, files: Array<{ __typename?: 'OpusAgentTurnFile', id: string, name: string, contentType: string, sizeBytes: number, rowCount?: number | null, expiresAt: string }>, attachments: Array<{ __typename?: 'OpusAgentTurnAttachment', id: string, index: number, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, libraryItem?: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null } | null }>, myFeedback?: { __typename?: 'OpusAgentChatTurnFeedback', id: string, selection: Types.FeedbackSelection, text: string } | null, events: Array<{ __typename?: 'OpusAgentChatTurnEvent', id: string, index: number, eventType: string, createdAt: string, payload: { __typename?: 'OpusAgentEventPayload', fallbackText?: string | null, assistantText?: { __typename?: 'OpusAgentAssistantText', text: string } | null, thinking?: { __typename?: 'OpusAgentThinking', text: string } | null, toolCall?: { __typename?: 'OpusAgentToolCall', callId?: string | null, toolName: string, label: string, status: string, detail?: string | null, errorSummary?: string | null, mutationNames?: Array<string> | null } | null, planUpdate?: { __typename?: 'OpusAgentPlanUpdate', done: number, total: number, activeStep?: string | null, items: Array<{ __typename?: 'OpusAgentPlanItem', text: string, status: string }> } | null, error?: { __typename?: 'OpusAgentError', message: string, code?: Types.OpusAgentRefusalCode | null } | null, contextCompacted?: { __typename?: 'OpusAgentContextCompacted', summaryChars: number } | null, planProposal?: { __typename?: 'OpusAgentPlanProposal', version: number, title: string, kind: string, summary?: string | null, audience?: string | null, language?: string | null, sources: Array<string>, assumptions: Array<string>, changes: Array<string>, items: Array<{ __typename?: 'OpusAgentPlanProposalItem', title: string, kind?: string | null, summary?: string | null, points: Array<string>, isNew: boolean, section?: string | null }> } | null, questions?: { __typename?: 'OpusAgentQuestions', questions: Array<{ __typename?: 'OpusAgentQuestion', id: string, text: string, options: Array<string>, multiSelect: boolean }> } | null } }> } | null } };

export type AbortOpusAgentTurnMutationVariables = Types.Exact<{
  turnId: Types.Scalars['UUID']['input'];
}>;


export type AbortOpusAgentTurnMutation = { __typename?: 'Mutation', abortOpusAgentTurn: { __typename?: 'AbortOpusAgentTurnResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, turn?: { __typename?: 'OpusAgentChatTurn', id: string, status: Types.OpusAgentChatTurnStatus, completedAt?: string | null } | null } };

export type EditOpusAgentMessageMutationVariables = Types.Exact<{
  turnId: Types.Scalars['UUID']['input'];
  newMessage: Types.Scalars['String']['input'];
}>;


export type EditOpusAgentMessageMutation = { __typename?: 'Mutation', editOpusAgentMessage: { __typename?: 'EditOpusAgentMessageResult', success: boolean, error?: { __typename?: 'Error', code: string, message?: string | null } | null, turn?: { __typename?: 'OpusAgentChatTurn', id: string, chatId: string, userMessage: string, status: Types.OpusAgentChatTurnStatus, model?: Types.OpusAgentModel | null, createdAt: string, completedAt?: string | null, supersededByEditAt?: string | null, citations: Array<{ __typename?: 'OpusAgentCitation', type: string, title?: string | null, quote?: string | null, libraryItemId?: string | null, url?: string | null }>, files: Array<{ __typename?: 'OpusAgentTurnFile', id: string, name: string, contentType: string, sizeBytes: number, rowCount?: number | null, expiresAt: string }>, attachments: Array<{ __typename?: 'OpusAgentTurnAttachment', id: string, index: number, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, libraryItem?: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', uuid: string, en: string }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null } | null }>, myFeedback?: { __typename?: 'OpusAgentChatTurnFeedback', id: string, selection: Types.FeedbackSelection, text: string } | null, events: Array<{ __typename?: 'OpusAgentChatTurnEvent', id: string, index: number, eventType: string, createdAt: string, payload: { __typename?: 'OpusAgentEventPayload', fallbackText?: string | null, assistantText?: { __typename?: 'OpusAgentAssistantText', text: string } | null, thinking?: { __typename?: 'OpusAgentThinking', text: string } | null, toolCall?: { __typename?: 'OpusAgentToolCall', callId?: string | null, toolName: string, label: string, status: string, detail?: string | null, errorSummary?: string | null, mutationNames?: Array<string> | null } | null, planUpdate?: { __typename?: 'OpusAgentPlanUpdate', done: number, total: number, activeStep?: string | null, items: Array<{ __typename?: 'OpusAgentPlanItem', text: string, status: string }> } | null, error?: { __typename?: 'OpusAgentError', message: string, code?: Types.OpusAgentRefusalCode | null } | null, contextCompacted?: { __typename?: 'OpusAgentContextCompacted', summaryChars: number } | null, planProposal?: { __typename?: 'OpusAgentPlanProposal', version: number, title: string, kind: string, summary?: string | null, audience?: string | null, language?: string | null, sources: Array<string>, assumptions: Array<string>, changes: Array<string>, items: Array<{ __typename?: 'OpusAgentPlanProposalItem', title: string, kind?: string | null, summary?: string | null, points: Array<string>, isNew: boolean, section?: string | null }> } | null, questions?: { __typename?: 'OpusAgentQuestions', questions: Array<{ __typename?: 'OpusAgentQuestion', id: string, text: string, options: Array<string>, multiSelect: boolean }> } | null } }> } | null } };

export const OpusAgentCitationFieldsFragmentDoc = gql`
    fragment OpusAgentCitationFields on OpusAgentCitation {
  type
  title
  quote
  libraryItemId
  url
}
    `;
export const OpusAgentTurnFileFieldsFragmentDoc = gql`
    fragment OpusAgentTurnFileFields on OpusAgentTurnFile {
  id
  name
  contentType
  sizeBytes
  rowCount
  expiresAt
}
    `;
export const OpusAgentEventFragmentDoc = gql`
    fragment OpusAgentEvent on OpusAgentChatTurnEvent {
  id
  index
  eventType
  createdAt
  payload {
    fallbackText
    assistantText {
      text
    }
    thinking {
      text
    }
    toolCall {
      callId
      toolName
      label
      status
      detail
      errorSummary
      mutationNames
    }
    planUpdate {
      done
      total
      activeStep
      items {
        text
        status
      }
    }
    error {
      message
      code
    }
    contextCompacted {
      summaryChars
    }
    planProposal {
      version
      title
      kind
      summary
      audience
      language
      sources
      items {
        title
        kind
        summary
        points
        isNew
        section
      }
      assumptions
      changes
    }
    questions {
      questions {
        id
        text
        options
        multiSelect
      }
    }
  }
}
    `;
export const OpusAgentTurnFragmentDoc = gql`
    fragment OpusAgentTurn on OpusAgentChatTurn {
  id
  chatId
  userMessage
  status
  model
  createdAt
  completedAt
  supersededByEditAt
  citations {
    ...OpusAgentCitationFields
  }
  files {
    ...OpusAgentTurnFileFields
  }
  attachments {
    ...OpusAgentTurnAttachmentFields
  }
  myFeedback {
    id
    selection
    text
  }
  events {
    ...OpusAgentEvent
  }
}
    ${OpusAgentCitationFieldsFragmentDoc}
${OpusAgentTurnFileFieldsFragmentDoc}
${OpusAgentTurnAttachmentFieldsFragmentDoc}
${OpusAgentEventFragmentDoc}`;
export const OpusAgentChatModelSeedFragmentDoc = gql`
    fragment OpusAgentChatModelSeed on OpusAgentChat {
  model
}
    `;
export const OpusAgentChatDocument = gql`
    query OpusAgentChat($id: UUID!) {
  OpusAgentChat(id: $id) {
    id
    createdAt
    model
    turns {
      ...OpusAgentTurn
    }
  }
}
    ${OpusAgentTurnFragmentDoc}`;

/**
 * __useOpusAgentChatQuery__
 *
 * To run a query within a React component, call `useOpusAgentChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOpusAgentChatQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentChatQuery, OpusAgentChatQueryVariables> & ({ variables: OpusAgentChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentChatQuery, OpusAgentChatQueryVariables>(OpusAgentChatDocument, options);
      }
export function useOpusAgentChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentChatQuery, OpusAgentChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentChatQuery, OpusAgentChatQueryVariables>(OpusAgentChatDocument, options);
        }
export type OpusAgentChatQueryHookResult = ReturnType<typeof useOpusAgentChatQuery>;
export type OpusAgentChatLazyQueryHookResult = ReturnType<typeof useOpusAgentChatLazyQuery>;
export type OpusAgentChatQueryResult = Apollo.QueryResult<OpusAgentChatQuery, OpusAgentChatQueryVariables>;
export const OpusAgentDefaultModelDocument = gql`
    query OpusAgentDefaultModel {
  OpusAgentDefaultModel
}
    `;

/**
 * __useOpusAgentDefaultModelQuery__
 *
 * To run a query within a React component, call `useOpusAgentDefaultModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentDefaultModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentDefaultModelQuery({
 *   variables: {
 *   },
 * });
 */
export function useOpusAgentDefaultModelQuery(baseOptions?: Apollo.QueryHookOptions<OpusAgentDefaultModelQuery, OpusAgentDefaultModelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentDefaultModelQuery, OpusAgentDefaultModelQueryVariables>(OpusAgentDefaultModelDocument, options);
      }
export function useOpusAgentDefaultModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentDefaultModelQuery, OpusAgentDefaultModelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentDefaultModelQuery, OpusAgentDefaultModelQueryVariables>(OpusAgentDefaultModelDocument, options);
        }
export type OpusAgentDefaultModelQueryHookResult = ReturnType<typeof useOpusAgentDefaultModelQuery>;
export type OpusAgentDefaultModelLazyQueryHookResult = ReturnType<typeof useOpusAgentDefaultModelLazyQuery>;
export type OpusAgentDefaultModelQueryResult = Apollo.QueryResult<OpusAgentDefaultModelQuery, OpusAgentDefaultModelQueryVariables>;
export const OpusAgentMostRecentChatDocument = gql`
    query OpusAgentMostRecentChat($agentId: UUID, $limit: Int = 1) {
  OpusAgentChats(
    input: {filters: {agentId: $agentId}}
    pagination: {limit: $limit, offset: 0}
  ) {
    objects {
      id
    }
  }
}
    `;

/**
 * __useOpusAgentMostRecentChatQuery__
 *
 * To run a query within a React component, call `useOpusAgentMostRecentChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentMostRecentChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentMostRecentChatQuery({
 *   variables: {
 *      agentId: // value for 'agentId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useOpusAgentMostRecentChatQuery(baseOptions?: Apollo.QueryHookOptions<OpusAgentMostRecentChatQuery, OpusAgentMostRecentChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentMostRecentChatQuery, OpusAgentMostRecentChatQueryVariables>(OpusAgentMostRecentChatDocument, options);
      }
export function useOpusAgentMostRecentChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentMostRecentChatQuery, OpusAgentMostRecentChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentMostRecentChatQuery, OpusAgentMostRecentChatQueryVariables>(OpusAgentMostRecentChatDocument, options);
        }
export type OpusAgentMostRecentChatQueryHookResult = ReturnType<typeof useOpusAgentMostRecentChatQuery>;
export type OpusAgentMostRecentChatLazyQueryHookResult = ReturnType<typeof useOpusAgentMostRecentChatLazyQuery>;
export type OpusAgentMostRecentChatQueryResult = Apollo.QueryResult<OpusAgentMostRecentChatQuery, OpusAgentMostRecentChatQueryVariables>;
export const OpusAgentTurnsDocument = gql`
    query OpusAgentTurns($input: OpusAgentTurnsInput!, $pagination: PaginationInput) {
  OpusAgentTurns(input: $input, pagination: $pagination) {
    objects {
      id
      status
      completedAt
      supersededByEditAt
      citations {
        ...OpusAgentCitationFields
      }
      files {
        ...OpusAgentTurnFileFields
      }
    }
  }
}
    ${OpusAgentCitationFieldsFragmentDoc}
${OpusAgentTurnFileFieldsFragmentDoc}`;

/**
 * __useOpusAgentTurnsQuery__
 *
 * To run a query within a React component, call `useOpusAgentTurnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentTurnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentTurnsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useOpusAgentTurnsQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentTurnsQuery, OpusAgentTurnsQueryVariables> & ({ variables: OpusAgentTurnsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentTurnsQuery, OpusAgentTurnsQueryVariables>(OpusAgentTurnsDocument, options);
      }
export function useOpusAgentTurnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentTurnsQuery, OpusAgentTurnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentTurnsQuery, OpusAgentTurnsQueryVariables>(OpusAgentTurnsDocument, options);
        }
export type OpusAgentTurnsQueryHookResult = ReturnType<typeof useOpusAgentTurnsQuery>;
export type OpusAgentTurnsLazyQueryHookResult = ReturnType<typeof useOpusAgentTurnsLazyQuery>;
export type OpusAgentTurnsQueryResult = Apollo.QueryResult<OpusAgentTurnsQuery, OpusAgentTurnsQueryVariables>;
export const OpusAgentTurnPreviewsDocument = gql`
    query OpusAgentTurnPreviews($input: OpusAgentTurnsInput!, $pagination: PaginationInput) {
  OpusAgentTurns(input: $input, pagination: $pagination) {
    objects {
      id
      partialText
    }
  }
}
    `;

/**
 * __useOpusAgentTurnPreviewsQuery__
 *
 * To run a query within a React component, call `useOpusAgentTurnPreviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentTurnPreviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentTurnPreviewsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useOpusAgentTurnPreviewsQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentTurnPreviewsQuery, OpusAgentTurnPreviewsQueryVariables> & ({ variables: OpusAgentTurnPreviewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentTurnPreviewsQuery, OpusAgentTurnPreviewsQueryVariables>(OpusAgentTurnPreviewsDocument, options);
      }
export function useOpusAgentTurnPreviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentTurnPreviewsQuery, OpusAgentTurnPreviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentTurnPreviewsQuery, OpusAgentTurnPreviewsQueryVariables>(OpusAgentTurnPreviewsDocument, options);
        }
export type OpusAgentTurnPreviewsQueryHookResult = ReturnType<typeof useOpusAgentTurnPreviewsQuery>;
export type OpusAgentTurnPreviewsLazyQueryHookResult = ReturnType<typeof useOpusAgentTurnPreviewsLazyQuery>;
export type OpusAgentTurnPreviewsQueryResult = Apollo.QueryResult<OpusAgentTurnPreviewsQuery, OpusAgentTurnPreviewsQueryVariables>;
export const OpusAgentTurnEventsDocument = gql`
    query OpusAgentTurnEvents($input: OpusAgentTurnEventsInput!, $pagination: PaginationInput) {
  OpusAgentTurnEvents(input: $input, pagination: $pagination) {
    objects {
      ...OpusAgentEvent
    }
  }
}
    ${OpusAgentEventFragmentDoc}`;

/**
 * __useOpusAgentTurnEventsQuery__
 *
 * To run a query within a React component, call `useOpusAgentTurnEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpusAgentTurnEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpusAgentTurnEventsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useOpusAgentTurnEventsQuery(baseOptions: Apollo.QueryHookOptions<OpusAgentTurnEventsQuery, OpusAgentTurnEventsQueryVariables> & ({ variables: OpusAgentTurnEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpusAgentTurnEventsQuery, OpusAgentTurnEventsQueryVariables>(OpusAgentTurnEventsDocument, options);
      }
export function useOpusAgentTurnEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpusAgentTurnEventsQuery, OpusAgentTurnEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpusAgentTurnEventsQuery, OpusAgentTurnEventsQueryVariables>(OpusAgentTurnEventsDocument, options);
        }
export type OpusAgentTurnEventsQueryHookResult = ReturnType<typeof useOpusAgentTurnEventsQuery>;
export type OpusAgentTurnEventsLazyQueryHookResult = ReturnType<typeof useOpusAgentTurnEventsLazyQuery>;
export type OpusAgentTurnEventsQueryResult = Apollo.QueryResult<OpusAgentTurnEventsQuery, OpusAgentTurnEventsQueryVariables>;
export const SendOpusAgentMessageDocument = gql`
    mutation SendOpusAgentMessage($input: SendOpusAgentMessageInput!) {
  sendOpusAgentMessage(input: $input) {
    success
    error {
      code
      message
    }
    turn {
      ...OpusAgentTurn
    }
  }
}
    ${OpusAgentTurnFragmentDoc}`;
export type SendOpusAgentMessageMutationFn = Apollo.MutationFunction<SendOpusAgentMessageMutation, SendOpusAgentMessageMutationVariables>;

/**
 * __useSendOpusAgentMessageMutation__
 *
 * To run a mutation, you first call `useSendOpusAgentMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOpusAgentMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOpusAgentMessageMutation, { data, loading, error }] = useSendOpusAgentMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendOpusAgentMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendOpusAgentMessageMutation, SendOpusAgentMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendOpusAgentMessageMutation, SendOpusAgentMessageMutationVariables>(SendOpusAgentMessageDocument, options);
      }
export type SendOpusAgentMessageMutationHookResult = ReturnType<typeof useSendOpusAgentMessageMutation>;
export type SendOpusAgentMessageMutationResult = Apollo.MutationResult<SendOpusAgentMessageMutation>;
export type SendOpusAgentMessageMutationOptions = Apollo.BaseMutationOptions<SendOpusAgentMessageMutation, SendOpusAgentMessageMutationVariables>;
export const AbortOpusAgentTurnDocument = gql`
    mutation AbortOpusAgentTurn($turnId: UUID!) {
  abortOpusAgentTurn(turnId: $turnId) {
    success
    error {
      code
      message
    }
    turn {
      id
      status
      completedAt
    }
  }
}
    `;
export type AbortOpusAgentTurnMutationFn = Apollo.MutationFunction<AbortOpusAgentTurnMutation, AbortOpusAgentTurnMutationVariables>;

/**
 * __useAbortOpusAgentTurnMutation__
 *
 * To run a mutation, you first call `useAbortOpusAgentTurnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAbortOpusAgentTurnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [abortOpusAgentTurnMutation, { data, loading, error }] = useAbortOpusAgentTurnMutation({
 *   variables: {
 *      turnId: // value for 'turnId'
 *   },
 * });
 */
export function useAbortOpusAgentTurnMutation(baseOptions?: Apollo.MutationHookOptions<AbortOpusAgentTurnMutation, AbortOpusAgentTurnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AbortOpusAgentTurnMutation, AbortOpusAgentTurnMutationVariables>(AbortOpusAgentTurnDocument, options);
      }
export type AbortOpusAgentTurnMutationHookResult = ReturnType<typeof useAbortOpusAgentTurnMutation>;
export type AbortOpusAgentTurnMutationResult = Apollo.MutationResult<AbortOpusAgentTurnMutation>;
export type AbortOpusAgentTurnMutationOptions = Apollo.BaseMutationOptions<AbortOpusAgentTurnMutation, AbortOpusAgentTurnMutationVariables>;
export const EditOpusAgentMessageDocument = gql`
    mutation EditOpusAgentMessage($turnId: UUID!, $newMessage: String!) {
  editOpusAgentMessage(turnId: $turnId, newMessage: $newMessage) {
    success
    error {
      code
      message
    }
    turn {
      ...OpusAgentTurn
    }
  }
}
    ${OpusAgentTurnFragmentDoc}`;
export type EditOpusAgentMessageMutationFn = Apollo.MutationFunction<EditOpusAgentMessageMutation, EditOpusAgentMessageMutationVariables>;

/**
 * __useEditOpusAgentMessageMutation__
 *
 * To run a mutation, you first call `useEditOpusAgentMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditOpusAgentMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editOpusAgentMessageMutation, { data, loading, error }] = useEditOpusAgentMessageMutation({
 *   variables: {
 *      turnId: // value for 'turnId'
 *      newMessage: // value for 'newMessage'
 *   },
 * });
 */
export function useEditOpusAgentMessageMutation(baseOptions?: Apollo.MutationHookOptions<EditOpusAgentMessageMutation, EditOpusAgentMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditOpusAgentMessageMutation, EditOpusAgentMessageMutationVariables>(EditOpusAgentMessageDocument, options);
      }
export type EditOpusAgentMessageMutationHookResult = ReturnType<typeof useEditOpusAgentMessageMutation>;
export type EditOpusAgentMessageMutationResult = Apollo.MutationResult<EditOpusAgentMessageMutation>;
export type EditOpusAgentMessageMutationOptions = Apollo.BaseMutationOptions<EditOpusAgentMessageMutation, EditOpusAgentMessageMutationVariables>;